import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type ClockIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

// Design Library · Foundation → Iconography → "clock" (node 941:2349). Drawn on a
// 20×20 frame with the glyph inset 8.33% (translate 0.9167), stroke 1.5, round caps.
export const ClockIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: ClockIconProps) => {
  const resolvedColor =
    color ??
    tokenVar(
      colorScheme === 'light'
        ? 'colors.light.icon.secondary'
        : 'colors.icon.secondary'
    )
  return (
    <svg
      aria-label='Clock'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.08333 4.08333V9.08333L12.4167 10.75M17.4167 9.08333C17.4167 13.6857 13.6857 17.4167 9.08333 17.4167C4.48096 17.4167 0.75 13.6857 0.75 9.08333C0.75 4.48096 4.48096 0.75 9.08333 0.75C13.6857 0.75 17.4167 4.48096 17.4167 9.08333Z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        transform='translate(0.9167 0.9167)'
      />
    </svg>
  )
}
